module.exports = __webpack_public_path__ + "img/flower.d2d60117.svg";